
@if(viewState().showBudgetMessage) {

<div class="mb-4">
    <mce-info-message typeof="information">
        <div class="text-lg font-bold"><h2>Set your monthly budget</h2></div>
        <div class="mt-4 mb-2 font-bold"><h3>Pay as you go</h3></div>
        <div>
            <p>
                Your subscription includes a monthly credit allowance. Once you have used these credits, you will be charged for each additional credit you use. You only pay for the credits you actually use.
            </p>

        </div>
        <div class="mt-4 mb-2 font-bold">
            <h3>Control your spending</h3>
        </div>
        <div>
            <p>Set a monthly budget to prevent unexpected charges. When your budget is reached, the application will prevent further paid credit usage.</p>
            <p>Your budget is currently set to <b>£0</b>, so you cannot use credits beyond those included with your subscription.</p>
            <p>We recommend setting a budget based on your expected usage and the amount you are comfortable spending.</p>
        </div>

    </mce-info-message>

</div>
}

<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>
            <div class="flex items-center gap-2">
                <mat-icon>account_balance</mat-icon>
                <span>Balance</span>
                <span class="border-outline ml-2 rounded border border-solid px-2 py-0.5 text-sm font-medium">
                    {{currentPlanName()}} plan
                </span>
                @if (accountCreditBadge(); as accountCredit) {
                <span class="border-outline rounded border border-solid px-2 py-0.5 text-sm font-medium">
                    {{accountCredit}}
                </span>
                }
            </div>
        </mat-card-title>
        <mat-card-subtitle>
            {{viewState().subscriptionStatusMessage }}
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        @let vm = viewState();



        <div class="mt-4 flex flex-col gap-6">
            <div class="grid gap-4 md:grid-cols-2">
                @for (metric of vm.consumptionMetrics; track metric.key) {
                <div class="border-outline flex flex-col gap-4 rounded border border-solid p-4">
                    @if (metric.key === 'payg' && vm.isFreePlan) {
                    <div class="flex items-center gap-2">
                        <mat-icon>payments</mat-icon>
                        <h2 class="m-0 text-xl">PAYG consumption</h2>
                    </div>

                    <div class="flex flex-1 flex-col items-center justify-center gap-2 py-4 text-center">
                        <mat-icon>lock</mat-icon>
                        <p class="m-0 font-medium">PAYG is available on Pro.</p>
                    </div>
                    } @else {
                    <div class="flex items-start justify-between gap-4">
                        <div class="flex items-center gap-2">
                            <mat-icon>{{metric.icon}}</mat-icon>
                            <h2 class="m-0 text-xl">{{metric.label}}</h2>
                        </div>
                        <div class="text-2xl font-medium">{{metric.percentComplete}}%</div>
                    </div>

                    <mat-progress-bar mode="determinate" [value]="metric.percentComplete"></mat-progress-bar>

                    <dl class="m-0 grid gap-2">
                        <div class="flex justify-between gap-4">
                            <dt>Used</dt>
                            <dd class="m-0 text-right">{{metric.usedLabel}}</dd>
                        </div>
                        <div class="flex justify-between gap-4">
                            <dt>Limit</dt>
                            <dd class="m-0 text-right">{{metric.limitLabel}}</dd>
                        </div>
                        <div class="flex justify-between gap-4">
                            <dt>Remaining</dt>
                            <dd class="m-0 text-right">{{metric.remainingLabel}}</dd>
                        </div>
                    </dl>
                    }
                </div>
                }
            </div>

        </div>
    </mat-card-content>

    <mat-card-actions align="end">
        <button matButton type="button" [disabled]="viewState().isFreePlan" (click)="setPaygBudget()" autofocus>
            Set PAYG Budget
        </button>
        <button matButton type="button" (click)="viewCreditCosts()">
            View Credit Costs
        </button>
        <a matButton [href]="pricingCreditsUrl" target="_blank" rel="noopener noreferrer"
           aria-label="Open Pricing and Credits help in a new tab">
            <mat-icon>open_in_new</mat-icon>
            How Pricing &amp; Credits Work
        </a>
    </mat-card-actions>

</mat-card>
